import React from "react";

export function EmptyWidget(props) {
  return <div></div>;
}
